import createAxiosInstance from './createAxiosInstance'

const instance = createAxiosInstance(`${process.env.VUE_APP_SBS_URL}/api`)

// Swagger: https://sbs-api-dev.kingnetsmart.com.tw/swagger/index.html#/CommunitiesAssets
export const apiAsset = {
  // tab
  Asset: {
    GetAssets: (requestData, config) => instance.get('/Communities/Assets', Object.assign({}, { params: requestData }, config)), // 取得資產設備列表
    PostAsset: (requestData, config) => instance.post('v1.1.1/Communities/Assets', requestData, config), // 新增資產設備
    GetAsset: (requestData, config) => instance.get(`/Communities/Assets/${requestData.AssetId}`, config), // 取得資產設備列表
    PutAsset: (requestData, config) => instance.put(`/Communities/Assets/${requestData.AssetId}`, requestData, config), // 編輯資產設備
    DeleteAsset: (requestData, config) => instance.delete(`/Communities/Assets/${requestData.AssetId}`, config), // 刪除資產設備
    DeleteAssets: (requestData, config) => instance.delete('/Communities/Assets', Object.assign({}, { data: requestData }, config)), // 批次刪除資產設備
    PostAttachments: (requestData, config) => instance.post(`/Communities/Assets/${requestData.AssetId}/Attachments`, requestData.FormData, config), // 新增資產之附件
    GetAttachments: (requestData, config) => instance.get(`/Communities/Assets/${requestData.AssetId}/Attachments`, config), // 取得資產之附件
    DeleteAttachments: (requestData, config) => instance.delete(`/Communities/Assets/${requestData.AssetId}/Attachments`, Object.assign({}, { data: requestData }, config)), // 刪除資產之附件
    GetSuppliers: (requestData, config) => instance.get('/Communities/Suppliers', Object.assign({}, { params: requestData }, config)), // 取得社區廠商
    GetCategory: (config) => instance.get('/Communities/Category', config), // 取得社區資產分類
    GetAreas: (config) => instance.get('/Communities/Areas', config), // 取得社區之位置
    GetStatus: (config) => instance.get('/Assets/Status', config), // 取得資產狀態
    GetExcelExample: (config) => instance.get('/Assets/ExcelAssetsImportSampleFile', config), // 取得資產匯入範例
    GetExportExcelAsset: (config) => instance.get('/Communities/Search/ExcelAssets', config), // 匯出資產 Excel
    GetExportAssetQRCode: (config) => instance.get('/Communities/Search/AssetsQRCode', config), // 匯出資產 QRCode
    PostImportExcelAsset: (requestData, config) => instance.post('/Communities/ExcelAssets', requestData, config), // 匯入資產
    // 給 BA 告警管理用的
    getAssetsAbridgedList: (config) => instance.get('/Communities/AssetsAbridgedList', config)
  },
  Consumable: {
    GetConsumables: (requestData, config) => instance.get('/Communities/Consumables', Object.assign({}, { params: requestData }, config)), // 取得耗材列表
    PostConsumable: (requestData, config) => instance.post('/Communities/Consumables', requestData, config), // 新增耗材
    GetConsumable: (requestData, config) => instance.get(`/Communities/Consumables/${requestData.ConsumableId}`, config), // 取得耗材列表
    PutConsumable: (requestData, config) => instance.put(`/Communities/Consumables/${requestData.ConsumableId}`, requestData, config), // 編輯耗材
    DeleteConsumable: (requestData, config) => instance.delete(`/Communities/Consumables/${requestData.ConsumableId}`, config), // 刪除耗材
    GetExportExcelConsumable: (config) => instance.get('/Communities/Search/ExcelConsumables', config) // 匯出耗材 Excel
  },
  Supplier: {
    GetCityAreas: (config) => instance.get('/Communities/SupplierCityAreas', config), // 取得城市區域
    GetSupplierTypes: (config) => instance.get('/Communities/SupplierTypes', config), // 取得廠商分類
    GetExportExcelSupplier: (config) => instance.get('/Communities/Search/ExcelSuppliers', config), // 匯出廠商 Excel
    DeleteSupplier: (requestData, config) => instance.delete(`/Communities/Suppliers/${requestData.SupplierId}`, config), // 刪除廠商
    GetSupplier: (requestData, config) => instance.get(`/Communities/Suppliers/${requestData.SupplierId}`, config), // 取得廠商詳情
    PostSupplier: (requestData, config) => instance.post('/Communities/Suppliers', requestData, config), // 新增廠商
    PutSupplier: (requestData, config) => instance.put(`/Communities/Suppliers/${requestData.SupplierId}`, requestData, config), // 編輯廠商
    PostFiles: (requestData, config) => instance.post(`/Communities/Suppliers/${requestData.SupplierId}/Files`, requestData.FormData, config), // 新增廠商之附件
    DeleteFiles: (requestData, config) => instance.delete(`/Communities/Suppliers/${requestData.SupplierId}/Files`, Object.assign({}, { data: requestData.FormData }, config)) // 刪除廠商之附件
  },
  maintenance: {
    getMaintenancePlan: (config) => instance.get('/MaintenancePlan', config), // 取得維養列表
    getMaintenancePlanById: (id) => instance.get(`/MaintenancePlan/${id}`), // 取得維養計畫明細
    getMaintenancePlanRecordById: (id) => instance.get(`/MaintenanceRecord/Plan/${id}`), // 取得維養計畫紀錄
    postMaintenancePlan: (data) => instance.post('/MaintenancePlan', data), // 新增維養計畫
    postMaintenanceTerm: (data) => instance.post('/MaintenanceTerm', data), // 新增維養項目
    getMaintenanceTermsByPlan: (plainId) => instance.get(`/MaintenancePlan/${plainId}/Terms`), // 更新計畫中的維養項目
    getMaintenanceItemById: (itemId) => instance.get(`/MaintenanceTerm/${itemId}`), // 取得維養項目詳情
    getSupplierLoginToken: (SupplierId) => instance.post('/SupplierLogin', {
      SupplierId
    }), // 取得廠商巡檢 QRCode 用的 Token
    postSupplierMaintenanceLogin: (data, jwt) => instance.post('/SupplierLogin/Staff', data, {
      headers: {
        Authorization: `Bearer ${jwt}`
      },
      metadata: {
        isApiNoNeedToLoginCommunity: true
      }
    }), // 登入廠商巡檢，獲得回報用 Token
    getSupplierListWithPlan: () => instance.get('/MaintenancePlan/Supplier'), // 使用回報用 Token，取得有維養計畫的廠商列表
    // notGetSupplierMaintenanceList: (id, jwt) => instance.get(`MaintenanceRecord/Supplier/${id}`, {
    //   headers: {
    //     Authorization: `Bearer ${jwt}`
    //   }
    // }), // 還沒釐清這支 API 用途
    getSupplierMaintenanceList: (supplierId, communityId, jwt) => instance.get(`MaintenancePlan/Supplier/${supplierId}/Community/${communityId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      },
      metadata: {
        isApiNoNeedToLoginCommunity: true
      }
    }), // 取得廠商巡檢列表
    postSupplierMaintenanceReport: (data, jwt) => instance.post('/MaintenanceRecord', data, {
      headers: {
        Authorization: `Bearer ${jwt}`
      },
      metadata: {
        isApiNoNeedToLoginCommunity: true
      }
    }), // 廠商巡檢回報
    getCostEstimation: (years) => instance.get('/CostEstimation', { params: { Years: years } }), // 取得長期修繕金額預估
    getCostEstimationReplacement: (years) => instance.get('/CostEstimation/Replacement', { params: { Years: years } }), // 取得長期修繕金額預估 - 更換費用
    getCostEstimationMaintenance: (years) => instance.get('/CostEstimation/Maintenance', { params: { Years: years } }) // 取得長期修繕金額預估 - 維養費用
  }
}

// Swagger: https://sbs-api-dev.kingnetsmart.com.tw/swagger/index.html#/CenterMonitoring/
export const apiCenterMonitoring = {
  GetItems: () => instance.get('/CenterMonitoring/items') // 獲取當前社區中央監控系統清單 (已排序)
}
